import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches users by their IDs from the API
 *
 * @param {string[]} userIds - Array of user IDs to fetch
 * @returns {Promise<import('../types/User.api').IGetUsersByIdsApiResponse>} Users API response
 */
export const getUsersByIds = async (userIds) => {
  const userIdsParam = userIds.join(',');

  const response = await tempMeeApi.get('/auth-service/admin/users', {
    params: { userIds: userIdsParam },
  });

  return response.data;
};
